export default "__VITE_ASSET__uxB4jF5E__"